import { Box } from "@chakra-ui/react";
import { colors } from "../../theme/tokens/colors";
import MarkDownRender from "../MarkDownRender";

type IProps = {
  onClose: () => void;
  feedback: string;
};

const Toaster = ({ onClose, feedback }: IProps) => {
  const containeHintStyle = {
    bg: "#1D1600",
    width: { base: "100%", md: "29rem" },
    boxShadow: colors.shadow.warning,
    py: ".8rem",
    minH: "3rem",
    px: ".8rem",
    borderRadius: "1rem",
  };
  return (
    <Box onClick={onClose}>
      {feedback && (
        <Box sx={containeHintStyle}>
          <MarkDownRender content={feedback}></MarkDownRender>
        </Box>
      )}
    </Box>
  );
};

export default Toaster;
